
























































import { editFactory } from '@/main/pages';
import { NdSklad } from '@/modules/sklad/ndSklad';

import { editActions } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';

type NakFilter = {
	VyrobekndOzn: string | null;
	NdNr: string | null;
	NdText: string | null;
	SkladOzn: string | null;
};

export default editFactory(NAME, store).extend({
	props: {
		ndakceId: Number,
		skladOzn: String,
		text: String,
	},
	components: {
		NdSkladSelect: NdSklad.components.Select,
	},
	computed: {
		actionsMapper(): Record<string, string> {
			return {
				ndSklad: `${this.storeUri}/${editActions.ND_SKLAD_POLOZKY_MAPPER}`,
			};
		},
		ndskladFilter(): NakFilter {
			return {
				VyrobekndOzn: this.VyrobekndOzn,
				NdNr: this.NdNr,
				NdText: this.Text,
				SkladOzn: this.props?.filter?.skladOzn,
			};
		},
	},
	created() {
		this.Text = this.props.filter.text;
	},
	methods: {},
});
